
export const useDraggableStore = {

    state: ()/* : State */ => ({

        show: false,

        items: [],

        model: null, // model DB - ex: Skills, Tags, ...

    }),

    // getters: {

    // },

    actions: {

        setDraggables (elements, model, omit = []){

            // this.items = _.toArray(_.omit(elements, omit))
            this.items = _.map(_.toArray(elements), v=> { return _.omit(v, omit) })

            this.model = model

            this.show = true
        },

        closedDraggable (){
            this.show = false; // for re-enable buttons
            this.items = []
            this.model = null

        },
    }
}
